import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from './../../common/dialog';
import Input from './../../common/components/Input';
import Select from './../../common/components/Select';

class Form extends Component {
    static propTypes = {
        formValues: PropTypes.object,
        formErrors: PropTypes.object,
        formErrorMessages: PropTypes.object,
        handleUpdateFormValue: PropTypes.func,
        handleSaveElement: PropTypes.func,
        handleUpdateDayValue: PropTypes.func,
        handleCheckProperty: PropTypes.func,
        hideForm: PropTypes.func,
        isSavingForm: PropTypes.bool,
        isFetchingElement: PropTypes.bool
    };

    renderInput(label, name, type, required, colClass = 'col') {
        const { formValues, formErrors, handleUpdateFormValue, formErrorMessages } = this.props;
        return (
            <div className={colClass} key={name}>
                <label>{label} {required ? <span className="required">*</span> : null}</label>
                <Input
                    name={name}
                    required={required}
                    formValues={formValues}
                    formErrors={formErrors}
                    formErrorMessages={formErrorMessages}
                    handleUpdateFormValue={handleUpdateFormValue.bind(this, type, required)}
                />
            </div>
        );
    }

    renderSelect(label, name, options, required, colClass = 'col') {
        const { formValues, formErrors, handleUpdateFormValue } = this.props;
        return (
            <div className={colClass} key={name}>
                <label>{label} {required ? <span className="required">*</span> : null}</label>
                <Select
                    name={name}
                    required={required}
                    options={options}
                    formValues={formValues}
                    formErrors={formErrors}
                    handleUpdateFormValue={handleUpdateFormValue.bind(this, 'text', required)}
                />
            </div>
        );
    }

    render() {
        const { hideForm, handleSaveElement, isSavingForm, isFetchingElement } = this.props;

        let saveButtonLabel = 'Save';
        if (isSavingForm) {
            saveButtonLabel = <i className="fas fa-circle-notch fa-spin" />;
        }

        let form = (
            <form>
                <div className="row">
                    <div className="subtitle">Press Data</div>
                    <div className="w-100"></div>
                    {this.renderInput('Name', 'name', 'text', true)}
                    {this.renderInput('Ink Units', 'ink_units', 'number', true)}
                    <div className="w-100"></div>
                    {this.renderInput('Labor Rate', 'labor_rate', 'decimal', true)}
                    {this.renderInput('Labor Markup Rate', 'labor_markup_rate', 'decimal', true)}
                    <div className="w-100"></div>
                    {this.renderInput('Max. Paper Width (inches)', 'max_paper_width', 'decimal', true)}
                    {this.renderInput('Max. Paper Length (inches)', 'max_paper_length', 'decimal', true)}
                    <div className="w-100"></div>
                    {this.renderInput('Min. Paper Width (inches)', 'min_paper_width', 'decimal', true)}
                    {this.renderInput('Min. Paper Length (inches)', 'min_paper_length', 'decimal', true)}
                    <div className="w-100"></div>
                    {this.renderInput('Setup Cost', 'setup_cost', 'decimal', true)}
                    {this.renderInput('Wash Up Cost', 'wash_up_cost', 'decimal', true)}
                    <div className="w-100"></div>
                    {this.renderInput('Gripper Margin', 'gripper_margin', 'decimal', true)}
                    {this.renderInput('Left/Right/Tail Trim Margin', 'left_right_tail_trim', 'decimal', true)}
                    <div className="w-100"></div>
                    {this.renderInput('Color Bar Margin', 'color_bar_margin', 'decimal', true)}
                    {this.renderInput('Setup Make Ready', 'setup_make_ready', 'number', true)}
                    <div className="w-100"></div>
                    {this.renderInput('Plate Change Cost', 'plate_change_cost', 'decimal', true)}
                    {this.renderInput('Plate Cost', 'plate_cost', 'decimal', true)}
                    <div className="w-100"></div>
                    {this.renderSelect('Active', 'is_active', [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }], true)}
                    {this.renderSelect('Perfecting', 'is_perfecting', [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }], true)}
                    <div className="w-100"></div>
                    {this.renderSelect('Default', 'is_default', [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }], true, 'col-6')}
                </div>
            </form>
        );
        if (isFetchingElement) {
            form = <div className="loading-data"><i className="fas fa-circle-notch fa-spin" /> Loading data...</div>;
        }

        let actions = [
            <button key="save-button" className="btn btn-light btn-sm action-button" onClick={handleSaveElement} disabled={isSavingForm}>{saveButtonLabel}</button>,
            <button key="close-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideForm}>Close</button>
        ];
        return (
            <Dialog
                name="form"
                modal={false}
                actions={actions}
                contentStyle={{ width: 800 }}
                bodyStyle={{ overflow: 'initial' }}
            >
                <div className="form-container">{form}</div>
            </Dialog>
        );
    }
}

export default Form;
